import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.concat.js";
import http from '../axios';
import apiUrl from '../apiUrl';

// 工单列表
export var apiprojectList = function apiprojectList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.projectList,
    method: 'get',
    params: query
  });
};

// 工单数量
export var apiprojectCount = function apiprojectCount() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.projectCount,
    method: 'get',
    params: query
  });
};

// 工单详情
export var apiproject = function apiproject() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.project,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 留言列表
export var apimessageList = function apimessageList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.messageList,
    method: 'get',
    params: query
  });
};

// 留言
export var apimessage = function apimessage() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'post';
  return http.request({
    url: apiUrl.message,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 客户评价
export var apicustomereval = function apicustomereval() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.customereval,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 客户评价自定义字段
export var apievalextfieldform = function apievalextfieldform() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.evalExtFieldForm,
    method: 'get',
    params: query
  });
};
export var apiGetreturnVisitTask = function apiGetreturnVisitTask() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: "".concat(query.epId, "/returnVisit/task/").concat(query.oid),
    method: method,
    params: method === 'get' || method === 'delete' ? {} : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
export var apiGetreturnvisitTaskDetail = function apiGetreturnvisitTaskDetail() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: "/returnvisitTask/visitOrderDetail",
    method: method,
    params: query
  });
};
export var apiPostreturnvisitTaskSubmit = function apiPostreturnvisitTaskSubmit() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: "/returnvisitTask/submit",
    method: method,
    data: query
  });
};
export var apiordereeceiptNoLogin = function apiordereeceiptNoLogin() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: "/".concat(query.epId, "/").concat(apiUrl.orderReceipt, "/").concat(query.oid),
    method: method,
    params: method === 'get' || method === 'delete' ? {} : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
// 工单回执信息
export var apiordereeceipt = function apiordereeceipt() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.orderReceipt,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};
// ——————————————————————————————————————————————————————————
// 废弃接口
export var apicustomer = function apicustomer() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.customer,
    method: 'get',
    params: query
  });
};
export var apitaskOrderList = function apitaskOrderList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.taskOrderList,
    method: 'get',
    params: query
  });
};
export var apitaskOrderLinkList = function apitaskOrderLinkList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.taskOrderLinkList,
    method: 'get',
    params: query
  });
};
// 获取服务款项
export function getServiceAmount(data) {
  return http.request({
    url: '/settlement/details',
    method: 'get',
    params: data
  });
}
export function getOrderDetailCtrlList(data) {
  return http.request({
    url: '/detailcontrol/orderDetailControllerList',
    method: 'get',
    params: data
  });
}
export function getDetailCtrlFieldColumn(data) {
  return http.request({
    url: "/detailcontrol/getFieldName",
    method: 'get',
    params: data
  });
}
export function saveDetailCtrlForm(data) {
  return http.request({
    url: "/detailcontrol/saveField",
    method: 'post',
    data: data
  });
}
// 明细控件 保存自定义表单 编辑
export function saveDetailCtrlFormEdit(data) {
  return http.request({
    url: "/detailcontrol/updateField",
    method: 'post',
    data: data
  });
}
// 明细控件 table 数据
export function getDetailCtrlTableList(data) {
  return http.request({
    url: '/detailcontrol/fieldValues',
    method: 'get',
    params: data
  });
}
// 明细控件 自定义表单列表
export function getDetailCtrlCustomField(data) {
  return http.request({
    url: "/detailcontrol/forminfo",
    method: 'get',
    params: data
  });
}

// 明细控件 删除table列表项
export function deleteDetailCtrlTableList(data) {
  return http.request({
    url: "/detailcontrol/delete",
    method: 'delete',
    params: data
  });
}